exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tv-large-number p {\n  font-size: 1.5em;\n}\n\n.tv-large-number h1 {\n  font-size: 6em;\n}\n\n.tv-large-number h1 span {\n  font-size: 0.25em;\n}\n\n@media screen and (min-width: 30em) {\n  .tv-large-number h1 {\n    font-size: 8vw;\n  }\n  .tv-large-number h1 span {\n    font-size: 0.2em;\n  }\n}\n\n.dashboard-card {\n  background-color: hsla(0, 0%, 100%, 0.8);\n}\n\n.dashboard-card p {\n  font-weight: 500;\n}\n\n.dashboard-card .f-headline {\n  font-size: 3.3rem;\n  font-weight: 400;\n}\n\n@media screen and (max-width: 30em) {\n  .dashboard-card .f-headline {\n    font-size: 3rem;\n  }\n}\n", ""]);

// exports
